/**
 * PCOS Special Offer Page JavaScript
 * Handles image gallery, package selection, and add to cart functionality
 */

(function() {
  'use strict';

  // Global state
  let productData = null;
  let selectedPackage = 1; // Default to package 1 (Buy 3 + Get 3)
  let autoRefillEnabled = true; // Default to subscription enabled (checkbox starts active)
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    // Load product data from JSON
    loadProductData();
    
    // Initialize functionality
    initPackageSelection();
    initAutoRefill();
    initCheckout();
    initShippingDate();
    updatePriceDisplay();
    initRatingScrollToReviews();
  }

  /**
   * Click pdp-details__rating → scroll to Loox reviews (#looxReviews or #reviews)
   */
  function initRatingScrollToReviews() {
    const ratingElement = document.getElementById('pdpRating');
    if (!ratingElement) return;

    function scrollToReviews(e) {
      if (e) e.preventDefault();

      const reviewsSection = document.getElementById('looxReviews') || document.getElementById('reviews');
      if (!reviewsSection) return;

      const allHeaders = document.querySelectorAll('header, .header, .site-header, [id*="header"], [class*="header"]');
      const announcementBar = document.querySelector('.announcement-bar, .top-bar, [class*="announcement"]');

      let totalHeaderHeight = 0;

      allHeaders.forEach(function(header) {
        const styles = window.getComputedStyle(header);
        if (styles.position === 'fixed' || styles.position === 'sticky') {
          totalHeaderHeight = Math.max(totalHeaderHeight, header.offsetHeight);
        }
      });

      if (announcementBar) {
        const barStyles = window.getComputedStyle(announcementBar);
        if (barStyles.position === 'fixed' || barStyles.position === 'sticky') {
          totalHeaderHeight += announcementBar.offsetHeight;
        }
      }

      if (totalHeaderHeight === 0) totalHeaderHeight = 80;

      const offset = 20;
      const elementPosition = reviewsSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - totalHeaderHeight - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }

    ratingElement.addEventListener('click', scrollToReviews);

    const ratingLink = ratingElement.querySelector('.pdp-details__rating-link');
    if (ratingLink) {
      ratingLink.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        scrollToReviews(e);
      });
    }
  }
  
  // Load product and variant data from Liquid-generated JSON
  function loadProductData() {
    const dataElement = document.getElementById('pcos-special-offer-data');
    if (dataElement) {
      try {
        productData = JSON.parse(dataElement.textContent);
      } catch (e) {
        // Error parsing product data
      }
    }
  }
  
  // ========================================
  // IMAGE GALLERY FUNCTIONALITY
  // ========================================
  
  // ========================================
  // PACKAGE SELECTION FUNCTIONALITY
  // ========================================
  
  function initPackageSelection() {
    const packages = document.querySelectorAll('.pcos-special-offer-package');
    
    if (packages.length === 0) return;
    
    packages.forEach((pkg) => {
      pkg.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Remove active class from all packages
        packages.forEach((p) => {
          p.classList.remove('active');
        });
        
        // Add active class to clicked package
        pkg.classList.add('active');
        
        // Update selected package number
        const packageNumber = pkg.getAttribute('data-package');
        selectedPackage = parseInt(packageNumber);
        
        // Update price display
        updatePriceDisplay();
      });
    });
  }
  
  // Format money (cents to currency format) - matches Shopify format
  function formatMoney(cents) {
    // Method 1: Use Shopify's formatMoney (most reliable)
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents);
      } catch (e) {
        // Continue to next method
      }
    }
    
    // Method 2: Use BoosterTheme cfx if available
    if (window.BoosterTheme?.ELEMENTS?.cfx) {
      try {
        const cfx = window.BoosterTheme.ELEMENTS.cfx;
        const currency = window.Shopify?.currency?.active || 'USD';
        const format = cfx.getFormat(currency);
        if (format) {
          return cfx.formatMoney(cents, format);
        }
      } catch (e) {
        // Continue to next method
      }
    }
    
    // Method 3: Extract format from monthly amount span (never includes /mo suffix)
    const existingAmount = document.querySelector('.pcos-special-offer-package-price-monthly');
    if (existingAmount && existingAmount.textContent) {
      const sampleFormatted = existingAmount.textContent.trim();
      const priceRoot = existingAmount.closest('[data-subscription-price], [data-one-time-price]');
      const dataPrice = priceRoot?.getAttribute('data-subscription-price')
        || priceRoot?.getAttribute('data-one-time-price');

      if (dataPrice) {
        const newAmount = cents / 100;
        const numberPattern = /[\d,]+\.?\d*/;
        const numberMatch = sampleFormatted.match(numberPattern);

        if (numberMatch) {
          const sampleNumber = numberMatch[0];
          const hasDecimals = sampleNumber.includes('.');
          const hasCommas = sampleNumber.includes(',');

          let formattedNumber;
          if (hasDecimals) {
            formattedNumber = newAmount.toFixed(2);
          } else {
            formattedNumber = Math.floor(newAmount).toString();
          }

          if (hasCommas && formattedNumber.length > 3) {
            formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }

          return sampleFormatted.replace(numberPattern, formattedNumber);
        }
      }
    }
    
    // Method 4: Basic fallback
    const amount = cents / 100;
    if (amount % 1 === 0) {
      return '$' + Math.floor(amount).toString();
    } else {
      return '$' + amount.toFixed(2);
    }
  }
  
  function formatMonthlyAmount(cents, months) {
    const monthCount = parseInt(months, 10);
    if (!monthCount || monthCount <= 0) return formatMoney(cents);
    return formatMoney(Math.round(cents / monthCount));
  }

  function setMonthlyPrice(el, cents, months) {
    if (!el) return;
    const amountEl = el.querySelector('.pcos-special-offer-package-price-monthly');
    if (amountEl) {
      amountEl.textContent = formatMonthlyAmount(cents, months);
    }
  }

  // Percent matches monthly display: (compare_at - sale) / compare_at is same for totals or per-month.
  function formatSavingsLabel(compareAtCents, salePriceCents) {
    if (!compareAtCents || compareAtCents <= salePriceCents) return null;
    const percent = Math.round(((compareAtCents - salePriceCents) / compareAtCents) * 100);
    if (percent > 0) return 'SAVE ' + percent + '%';
    return 'SAVE ' + formatMoney(compareAtCents - salePriceCents);
  }

  // Subscribe = strikethrough $X/mo + sale $Y/mo + total. One-time = full pack price.
  function updatePriceDisplay() {
    const packages = document.querySelectorAll('.pcos-special-offer-package');
    
    packages.forEach((pkg) => {
      const priceBlock = pkg.querySelector('.pcos-special-offer-package-price');
      const priceEl = pkg.querySelector('.pcos-special-offer-package-price-active');
      const compareEl = pkg.querySelector('.pcos-special-offer-package-price-compare');
      const totalEl = pkg.querySelector('.pcos-special-offer-package-price-total');
      const subscribeBlock = pkg.querySelector('.pcos-package-price-subscribe');
      const onetimeBlock = pkg.querySelector('.pcos-package-price-onetime');
      const savingsBadge = pkg.querySelector('.pcos-special-offer-package-savings');
      
      if (!priceEl) return;

      const months = pkg.getAttribute('data-subscription-months');
      const subscriptionPrice = parseFloat(priceEl.getAttribute('data-subscription-price')) || 0;
      const oneTimePrice = parseFloat(priceEl.getAttribute('data-one-time-price')) || 0;
      const baseMonthlyStrike = parseFloat(priceBlock?.getAttribute('data-base-monthly-strike')) || 0;
      
      if (autoRefillEnabled) {
        if (subscribeBlock) subscribeBlock.style.display = 'flex';
        if (onetimeBlock) onetimeBlock.style.display = 'none';

        if (subscriptionPrice > 0 && months) {
          setMonthlyPrice(priceEl, subscriptionPrice, months);
        }

        if (compareEl && baseMonthlyStrike > 0) {
          setMonthlyPrice(compareEl, baseMonthlyStrike, 1);
          compareEl.style.display = 'block';
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }

        if (totalEl && subscriptionPrice > 0) {
          totalEl.textContent = formatMoney(subscriptionPrice) + ' total';
          totalEl.style.display = 'block';
        }
        
        // SAVE badge: dynamic % from Shopify compare_at vs subscription price
        if (savingsBadge) {
          const compareAtPrice = parseFloat(savingsBadge.getAttribute('data-compare-at-price')) || 0;
          const subPrice = parseFloat(savingsBadge.getAttribute('data-subscription-price')) || 0;
          const savingsLabel = formatSavingsLabel(compareAtPrice, subPrice);
          const savingsSpan = savingsBadge.querySelector('span');

          if (savingsLabel && savingsSpan) {
            savingsSpan.textContent = savingsLabel;
            savingsBadge.style.display = 'inline-flex';
          } else {
            savingsBadge.style.display = 'none';
          }
        }
      } else {
        if (subscribeBlock) subscribeBlock.style.display = 'none';
        if (onetimeBlock) onetimeBlock.style.display = 'block';

        const onetimeEl = pkg.querySelector('.pcos-special-offer-package-price-onetime');
        if (onetimeEl && oneTimePrice > 0) {
          onetimeEl.textContent = formatMoney(oneTimePrice);
        }
        if (savingsBadge) savingsBadge.style.display = 'none';
      }
    });
  }
  
  // ========================================
  // AUTO REFILL CHECKBOX FUNCTIONALITY
  // ========================================
  function updatePackageExtrasVisibility() {
    document.querySelectorAll('.pcos-package-extras-subscribe').forEach((el) => {
      el.style.display = autoRefillEnabled ? 'flex' : 'none';
    });
    document.querySelectorAll('.pcos-package-extras-onetime').forEach((el) => {
      el.style.display = autoRefillEnabled ? 'none' : 'flex';
    });
    document.querySelectorAll('.pcos-package-extra-subscribe').forEach((el) => {
      el.style.display = autoRefillEnabled ? 'flex' : 'none';
    });
  }

  function initAutoRefill() {
    const autoRefillCheckbox = document.querySelector('[data-auto-refill]');
    
    if (!autoRefillCheckbox) return;
    
    autoRefillCheckbox.addEventListener('click', function(e) {
      e.preventDefault();
      
      autoRefillCheckbox.classList.toggle('active');
      autoRefillEnabled = autoRefillCheckbox.classList.contains('active');
      
      updatePriceDisplay();
      updateFreeTextVisibility();
      updatePackageQuantities();
      updatePackageBadges();
      updateBaseTitles();
      updatePackageExtrasVisibility();
    });
    
    updateFreeTextVisibility();
    updatePackageQuantities();
    updatePackageBadges();
    updateBaseTitles();
    updatePackageExtrasVisibility();
  }
  
  // Update FREE text visibility based on subscription status
  function updateFreeTextVisibility() {
    const freeTextElements = document.querySelectorAll('.pcos-package-free-text');
    
    freeTextElements.forEach(freeText => {
      freeText.style.display = autoRefillEnabled ? 'inline' : 'none';
    });
  }
  
  // Update package quantities based on subscription status
  function updatePackageQuantities() {
    const packages = document.querySelectorAll('.pcos-special-offer-package');
    
    packages.forEach((pkg, index) => {
      const quantityElement = pkg.querySelector('.pcos-package-quantity');
      const pluralElement = pkg.querySelector('.pcos-package-plural');
      
      if (!quantityElement) return;
      
      // Define quantities for each package
      const subscriptionQuantities = [6, 4, 2]; // Package 1, 2, 3 when subscribed
      const oneTimeQuantities = [3, 2, 1];     // Package 1, 2, 3 when one-time
      
      if (autoRefillEnabled) {
        // Subscription: show total bottles (buy + free)
        quantityElement.textContent = subscriptionQuantities[index];
        if (pluralElement) pluralElement.style.display = 'inline'; // Always plural for subscription
      } else {
        // One-time: show only purchased bottles
        quantityElement.textContent = oneTimeQuantities[index];
        // Handle singular/plural for "bottle" vs "bottles"
        if (pluralElement) {
          pluralElement.style.display = oneTimeQuantities[index] === 1 ? 'none' : 'inline';
        }
      }
    });
  }

  // Update base titles to include singular/plural "bottle(s)" for one-time purchases
  function updateBaseTitles() {
    const baseTitleElements = document.querySelectorAll('.pcos-package-base-title');
    if (!baseTitleElements.length) return;

    const buyCounts = [3, 2, 1];

    baseTitleElements.forEach((el, idx) => {
      const count = buyCounts[idx] || '';
      if (autoRefillEnabled) {
        el.textContent = count ? `Buy ${count}` : el.textContent;
      } else if (count) {
        el.textContent = `Buy ${count} ${count === 1 ? 'bottle' : 'bottles'}`;
      }
    });
  }
  
  // Update package badges visibility based on subscription status
  function updatePackageBadges() {
    const badges = document.querySelectorAll('.pcos-special-offer-badge');
    
    badges.forEach(badge => {
      badge.style.display = autoRefillEnabled ? 'block' : 'none';
    });
  }
  
  // ========================================
  // DIRECT CHECKOUT (Skio 1-click — same as pricing-block-50-off)
  // ========================================

  function _bogoCheckoutTextEl(btn) {
    return btn && btn.querySelector('.pcos-special-offer-add-to-cart-text');
  }

  function _getBogoCheckoutText(btn) {
    const el = _bogoCheckoutTextEl(btn);
    return (el ? el.textContent : btn.textContent).trim();
  }

  function _setBogoCheckoutText(btn, text) {
    const el = _bogoCheckoutTextEl(btn);
    if (el) el.textContent = text;
    else if (btn) btn.textContent = text;
  }

  function _setBogoCheckoutBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = busy;
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
    btn.classList[busy ? 'add' : 'remove']('is-loading');
  }

  function buildSkioCheckoutUrl(variantData, withSellingPlan) {
    if (!variantData || !variantData.id) return '';

    let cartAdd = `/cart/add?items[0][id]=${variantData.id}&items[0][quantity]=1`;
    if (withSellingPlan && variantData.selling_plan_id) {
      cartAdd += `&items[0][selling_plan]=${variantData.selling_plan_id}`;
    }
    cartAdd += '&return_to=/checkout';

    return '/cart/clear?return_to=' + encodeURIComponent(cartAdd);
  }

  function initCheckout() {
    const checkoutBtn = document.querySelector('.pcos-special-offer-checkout');
    if (!checkoutBtn) return;

    checkoutBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const btn = this;
      if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

      const activePackage = document.querySelector('.pcos-special-offer-package.active');
      if (!activePackage) return;

      const packageNumber = activePackage.getAttribute('data-package');
      const packageKey = `package${packageNumber}`;
      const checkoutMode = autoRefillEnabled ? 'subscription' : 'onetime';
      const variantData = productData?.variants?.[checkoutMode]?.[packageKey];
      const checkoutUrl = buildSkioCheckoutUrl(variantData, checkoutMode === 'subscription');

      if (!checkoutUrl) return;

      const originalText = _getBogoCheckoutText(btn);
      _setBogoCheckoutBusy(btn, true);
      _setBogoCheckoutText(btn, 'Redirecting…');
      window.location.href = checkoutUrl;

      setTimeout(() => {
        _setBogoCheckoutBusy(btn, false);
        _setBogoCheckoutText(btn, originalText);
      }, 3000);
    });
  }
  
  // ========================================
  // SHIPPING DATE CALCULATION
  // ========================================
  
  function initShippingDate() {
    const shippingDateElement = document.querySelector('.pcos-special-offer-shipping-date');
    
    if (!shippingDateElement) return;
    
    // Calculate shipping date based on business rules:
    // - Orders placed before 7:45am MST ship the same day
    // - Orders placed after 7:45am MST ship the next day
    // - We do not ship on Sundays
    //   • If shipping date lands on Sunday, move to Monday
    //   • Orders placed after 7:45am MST on Saturday ship Monday
    const nowMST = getNowInMST();
    const shippingDate = getShippingDate(nowMST);
    
    // Format date as "Day, Mon DD" (e.g., "Mon, Jul 27")
    const formattedDate = formatShippingDate(shippingDate);
    
    // Update the element
    shippingDateElement.textContent = formattedDate;
  }
  
  // Get current Date object in MST using browser time zone support
  function getNowInMST() {
    try {
      // Use America/Denver which tracks Mountain Time including DST
      const now = new Date();
      const mstString = now.toLocaleString('en-US', { timeZone: 'America/Denver' });
      return new Date(mstString);
    } catch (e) {
      // Fallback: approximate Mountain Time as UTC-7
      const now = new Date();
      const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
      return new Date(utc - (7 * 60 * 60 * 1000));
    }
  }
  
  // Business rules for shipping date
  function getShippingDate(nowMST) {
    const shipping = new Date(nowMST.getTime());
    const day = shipping.getDay(); // 0 = Sun, 6 = Sat
    const cutoffHour = 7;
    const cutoffMinute = 45;
    
    const afterCutoff =
      shipping.getHours() > cutoffHour ||
      (shipping.getHours() === cutoffHour && shipping.getMinutes() >= cutoffMinute);
    
    // Helper to add days and skip Sunday if needed
    function addDaysSkippingSunday(date, daysToAdd) {
      const d = new Date(date.getTime());
      d.setDate(d.getDate() + daysToAdd);
      // If result is Sunday, move to Monday
      if (d.getDay() === 0) {
        d.setDate(d.getDate() + 1);
      }
      return d;
    }
    
    // Sunday: no shipping, always ship Monday
    if (day === 0) {
      return addDaysSkippingSunday(shipping, 1); // Monday
    }
    
    // Saturday logic
    if (day === 6) {
      if (afterCutoff) {
        // After 7:45am MST Saturday → ship Monday
        return addDaysSkippingSunday(shipping, 2);
      }
      // Before cutoff on Saturday → ship Saturday
      return shipping;
    }
    
    // Monday–Friday
    if (!afterCutoff) {
      // Before cutoff → ship same day
      return shipping;
    }
    
    // After cutoff → ship next day, skipping Sunday if needed
    return addDaysSkippingSunday(shipping, 1);
  }
  
  // Format date as "Day, Mon DD" (e.g., "Sun, Jul 27")
  function formatShippingDate(date) {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = date.getDate();
    
    return `${dayName}, ${monthName} ${day}`;
  }
  
  
})();
